import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getUserPeer2PeerHistory } from "@/services/program/getUserPeer2Peer";
import { formatPoints } from "./formatPoints";

const Peer2PeerHistory = ({ program, organization, auth }) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    if (organization?.id && program?.id && auth?.id) {
      getUserPeer2PeerHistory(organization.id, program.id, auth.id, 0, 99999999)
        .then(res => setData(res.results ?? []))
        .catch(() => {});
    }
  }, [organization, program, auth]);

  if (data.length === 0) return null;

  const fmt = (ts) =>
    new Date(ts.replace(' ', 'T')).toLocaleDateString('en-US', {
      month: 'short', day: 'numeric', year: 'numeric',
    });

  return (
    <div className="mp-table-wrap">
      <h2 className="mp-table-wrap__title">{t('peer_to_peer')}</h2>
      <table className="mp-table">
        <thead>
          <tr>
            <th>{t('event')}</th>
            <th>{t('date')}</th>
            <th>{t('Awarder')}</th>
            <th>{t('Awardee')}</th>
            <th className="mp-table__num">{t('points')}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => {
            const awarder = `${row.first_name ?? ''} ${row.last_name ?? ''}`.trim();
            return (
              <tr key={i}>
                <td data-label={t('event')}>{row.name}</td>
                <td className="mp-table__date" data-label={t('date')}>{fmt(row.journal_event_timestamp)}</td>
                <td data-label={t('Awarder')}>{awarder}</td>
                <td data-label={t('Awardee')}>{row.awardee_recipient}</td>
                <td className="mp-table__num" data-label={t('points')}>{formatPoints(row.amount * program.factor_valuation)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth:         state.auth,
  program:      state.program,
  organization: state.organization,
});

export default connect(mapStateToProps)(Peer2PeerHistory);
